<template>
  <div class="w-100" style="height: 92%">
    <div>
      <a-menu
        mode="horizontal"
        v-model="defaultSelectedKeys"
        @click="clickMenuItem"
      >
        <a-menu-item key="/equipment/preview/statistics">{{ $t('statistics') }}</a-menu-item>
        <a-menu-item key="/equipment/preview/setWarning">{{ $t('warn') }}</a-menu-item>
        <a-menu-item v-if="$route.query.type === 'DB'" key="/equipment/preview/dataReport">{{ $t('station.dataReport1') }}</a-menu-item>
        <a-menu-item v-if="$route.query.type === 'NXFXY'" key="/equipment/preview/dataStatistics">{{ $t('station.dataReport1') }}</a-menu-item>
        <a-button style="float: right; margin: 8px 5px 0 0;" @click="$router.back()">{{ $t('buttons.goBack') }}</a-button>
      </a-menu>
    </div>
    <div class="w-100 h-100">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultSelectedKeys: ['/equipment/preview/statistics']
    }
  },
  created () {
    if (this.$route.path) {
      this.defaultSelectedKeys = [this.$route.path]
    }
  },
  watch: {
    '$route.path'(p) {
      this.defaultSelectedKeys = [p]
    }
  },
  methods: {
    clickMenuItem ({ key }) {
      this.$router.push({ path: key, query: { code: this.$route.query.code, name: this.$route.query.name, driver: this.$route.query.driver, pc: this.$route.query.pc, type: this.$route.query.type, id: this.$route.query.id, ci: this.$route.query.ci } })
    }
  }
}
</script>

<style>

</style>